<template>
  <div class="about">
    <base-card>
      <h1>About NFL Ironman</h1>
      <base-card>
        <h2>{{ motdTitle }}</h2>
        <ul>
          <li v-for="messages in motd" :key="messages.date">Version <b>{{ messages.version }}</b> ({{ formattedDate(messages.date) }})
            <ul>
              <li v-for="line in messages.changes" :key="line" v-html="line"/>
            </ul>
          </li>
        </ul>
      </base-card>
    </base-card>
  </div>
</template>

<script>
import DateFunctions from "./../mixins/DateFunctions.js"

export default {
  mixins: [DateFunctions],
  data() {
    return {
      motdTitle: "Recent Changes",
      motd: [
      {
          version: '2024.1.1',
          date: new Date("August 13, 2024"),
          changes: [
            "Leave nickname blank so players will be required to enter one.",
          ],
        },
        {
          version: '2024.1.0',
          date: new Date("August 6, 2024"),
          changes: [
            "Changes for Ironman 2024 Season.",
          ],
        },
        {
          version: '2023.0.1',
          date: new Date("March 11, 2023"),
          changes: [
            "Started changes for Ironman 2023 Season.",
          ],
        },
        {
          version: '2022.1.2',
          date: new Date("September 15, 2022"),
          changes: [
            "Fixed a typo in the Weekly Games page.",
          ],
        },
        {
          version: '2022.1.1',
          date: new Date("August 8, 2022"),
          changes: [
            "Updated for 2022 to 2023 Season Data.",
          ],
        },
        {
          version: '0.1.30',
          date: new Date("January 18, 2022"),
          changes: [
            "Updated total score in Standings to take into consideration post-season (didn't update with fix in 0.1.29).",
          ],
        },
        {
          version: '0.1.29',
          date: new Date("January 14, 2022"),
          changes: [
            "Updated scoring to take into consideration post-season (any pick for the week matches all games).",
            "Updated Weekly Games to take into consideration post-season (same as scoring).",
            "Added a couple more colors for badges in Weekly Games to reduce conflicts.",
          ],
        },
        {
          version: '0.1.28',
          date: new Date("November 19, 2021"),
          changes: [
            "Updated to remove base card width (overall layout width) limit.",
            "Added Snackbar message when saving weekly results in Admin.",
            "Fixed a potential bug when highlighting lowest weekly score on Standings View.",
          ],
        },
        {
          version: '0.1.27',
          date: new Date("October 5, 2021"),
          changes: [
            "Updated to allow login to persist indefinitely.",
          ],
        },
        {
          version: '0.1.26',
          date: new Date("September 28, 2021"),
          changes: [
            "Added Points per Game to the Standings view.",
            "Updated a couple admin items.",
          ],
        },
        {
          version: '0.1.25',
          date: new Date("September 20, 2021"),
          changes: [
            "Added <a href='/ironman/weeklygames'>Weekly Games</a> view to the menus when logged in.",
            "Updated Standings (accessible via <a href='/ironman'>Home</a> or <a href='/ironman'>NFL Ironman</a> menu items) to show weekly results",
            "Fixed a bug in the Standings total where it was only showing the total score to the first non-blank winner for the week regardless if there were later games that had winners",
          ],
        },
        {
          version: '0.1.22 thru 0.1.24',
          date: new Date("September 8, 2021"),
          changes: [
            "Preliminary work on <a href='/ironman/weeklygames'>'Weekly Games'</a> view to show picks for upcoming / current week. I'll be adding into the menus later on. Let me know what you think!",
          ],
        },
        {
          version: '0.1.18 thru 0.1.21',
          date: new Date("September 6, 2021"),
          changes: [
            "Fixed a bug where the 'click Update to refresh' wasn't actually refreshing",
          ],
        },
        {
          version: '0.1.17',
          date: new Date("September 6, 2021"),
          changes: [
            "Added paid indicator on Home page",
          ],
        },
        {
          version: '0.1.16',
          date: new Date("September 5, 2021"),
          changes: [
            "Behind the scenes changes in administration",
          ],
        },
        {
          version: '0.1.15',
          date: new Date("August 30, 2021"),
          changes: [
            "Improvements to status messages in footer (snackbar)",
          ],
        },
        {
          version: '0.1.14',
          date: new Date("August 29, 2021"),
          changes: [
            "Fixed some color defaults",
            "Added admin option for updating weekly results",
          ],
        },
        {
          version: '0.1.13',
          date: new Date("August 17, 2021"),
          changes: [
            "Corrected issue with service worker registration",
          ],
        },
        {
          version: '0.1.12',
          date: new Date("August 17, 2021"),
          changes: [
            "Updated PWA Images and FavIcon and changed Theme Color for PWA App Toolbar",
          ],
        },
        {
          version: '0.1.11',
          date: new Date("August 16, 2021"),
          changes: [
            "Improved footer height / body padding",
            "Added Home to header menus (currently same as 'NFL Ironman')",
            "Added version numbering to About changes list",
            "Some miscellaneous cleanup",
          ],
        },
        {
          version: '0.1.10',
          date: new Date("August 16, 2021"),
          changes: [
            "Changed color scheme to Broncos colors for better contrast (incomplete)",
            "Fixed issue where invalid login didn't give an error and instead switched to a blank user profile page",
            "Updated buttons in various locations to be more responsive for mobile phones",
          ],
        },
        {
          version: '0.1.9',
          date: new Date("August 11, 2021"),
          changes: [
            "Data changes: deleted extraneous user accounts and all picks",
            "Default NickName to current UserName and don't allow it to be blank *or* duplicate",
            "Give user an error if they have incomplete picks and the tournament is closed (also don't allow editing if tournament is closed)",
            "Fixed bug where saving picks didn't add to the global picks list (missing in Standings)",
          ],
        },
        {
          version: '0.1.8',
          date: new Date("August 10, 2021"),
          changes: [
            "First pass at displaying real standings on home page",
            "Added 'hamburger' menu to header (only on small displays)",
            "First pass on making the site more responsive for mobile / tablets",
            "Cleaned up initial data loading",
          ],
        },
        {
          version: '0.1.7',
          date: new Date("August 6, 2021"),
          changes: [
            "Revamped the Picks page (if picks are 'complete', show recap)",
            "Many behind-the-scenes changes for database data and logging, probably broke stuff",
          ],
        },
        {
          version: '0.1.6',
          date: new Date("August 4, 2021"),
          changes: [
            "Database changes: Previously saved Picks were deleted",
            "Added Nickname on Picks Page (cannot be blank)",
            "Added Picks Complete/Incomplete Indicator on Picks Page",
            "Fixed bug so Division Winners are seeded correctly",
          ],
        },
        {
          version: '0.1.5',
          date: new Date("August 1, 2021"),
          changes: [
            "Added team filter to Regular Season Picks",
            "Moved Message of the Day (Recent Changes) to About and added About to the Header",
            "Added Version information to Footer",
          ],
        },
        {
          version: '0.1.4',
          date: new Date("July 31, 2021"),
          changes: [
            "Fixed a bug in Season Recap that could show the wrong 'visitor' team",
          ],
        },
        {
          version: '0.1.3',
          date: new Date("July 30, 2021"),
          changes: [
            "Added 'Login/Register' to Header",
            "Added more detailed errors for Register",
            "Added Season Summary",
            "Removed 'None' as a Picks option",
            "Added 'Message of the Day' to be displayed after Login",
            "Changed 'Your Picks' and 'Your Profile' to 'My Picks/Profile'",
          ]
        },
        // "("+process.env.NODE_ENV+")",
      ],
    }
  },
  computed: {
    appVersion () {
      return this.$store.getters.appVersion
    },
    appName() {
      return this.$store.getters.appName;
    },
    productionState() {
      return this.$store.getters.productionState;
    }
  },
}
</script>
